import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { BillingHistoryMonth, BillingHistoryResponse, BillingHistoryResponseSchema } from '@api/models/dashboard';
import { environment } from '@environments/environment';
import { from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BillingHistoryData extends ApiServiceBase<BillingHistoryMonth> {
  constructor() {
    super('stores', 'evoqAdmin');
  }

  fetchBillingHistory(storeId: string): Observable<BillingHistoryResponse> {
    if (environment.isMockEnabled) {
      return from(import('@mock/schema/dashboard/list.billing-history.mock')).pipe(
        map((mock) => mock.listBillingHistoryMock())
      );
    }

    // Admin API: GET /api/v1/stores/{storeId}/subscriptions returns the server-side
    // monthly aggregation (year, month, activeSubscriptions, totalPrice, charged).
    return this.customRequest<unknown>({ method: 'GET', url: `${storeId}/subscriptions` }).pipe(
      map((response) => {
        const result = BillingHistoryResponseSchema.safeParse(response);
        if (!result.success) {
          throw new Error('Invalid billing history response');
        }
        return result.data;
      })
    );
  }
}
